export const versionApi = {
  versionDetail: '/clouddm/console/api/v1/version/detail',
  versionCheck: '/clouddm/console/api/v1/version/check',
  versionIgnore: '/clouddm/console/api/v1/version/ignore'
};
